// ===================================================================
// src/app/components/auth/StaffRoute.tsx
//
// Guard de rota para telas internas da Eleve.IA (ex: revisão de
// cadastros de escola). Requer usuário autenticado com is_staff=true —
// usuários de escola (mesmo manager) nunca satisfazem esta condição.
// Deve ficar aninhado dentro de ProtectedRoute (assume sessão já resolvida).
// ===================================================================

import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../../contexts/AuthContext';

export default function StaffRoute() {
  const { user } = useAuth();

  if (!user?.is_staff) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
